import { useAppStore } from '../store';
import { Button } from './ui/Button';
import { CardTitle } from './ui/card';
import { SCREEN_TYPES } from 'utils/constants';

export const GradingDisabledScreen = () => {
  const { setCurrentScreen } = useAppStore();

  const handleClose = () => {
    setCurrentScreen(SCREEN_TYPES.APP_SELECT);
  };

  return (
    <div className="space-y-20">
      <CardTitle className="mb-1 flex items-center justify-center gap-3 text-center text-xl font-extrabold tracking-tight text-slate-900">
        Grading DISABLED
      </CardTitle>

      <p className="text-center font-bold text-slate-600">
        The Current Day's Grading is Closed. Please See a manager about opening a new day for
        processing.
      </p>

      <div className="buttons-container !border-none">
        <Button
          type="button"
          className="h-12 flex-1 rounded-xl text-base font-semibold shadow-sm"
          onClick={handleClose}
        >
          CLOSE
        </Button>
      </div>
    </div>
  );
};
